import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import { DefaultApiGenerateCreateAccountTokenRequest } from '@src/api/generated/user-api'

export const generateCreateAccountToken = async (
  instance: AxiosInstance,
  params: DefaultApiGenerateCreateAccountTokenRequest
) => {
  return await userApiDefaultApiFactory(instance).generateCreateAccountToken(
    params
  )
}

// Do Not Remove this line ===@import api client===
